<template>
  <div>
    <component
      v-for="([socialProfile, link], index) in isEditModeEnabled
        ? Object.entries(socialMedia)
        : activeSocialMedia"
      :key="index"
      :is="link ? 'a' : 'span'"
      class="tw-mx-1 tw-px-3 md:tw-mx-0 md:tw-px-2"
      :class="
        link
          ? 'tw-text-primary-500 hover:tw-text-primary-600'
          : 'tw-text-neutral-300 hover:tw-text-neutral-300'
      "
      :href="link"
      target="_blank"
    >
      <component :is="socialsIcons[socialProfile]" class="tw-h-4 tw-w-4" />
    </component>
    <EditSocialMedia
      v-if="isEditModeEnabled"
      :social-media="socialMedia"
      :url="url"
    />
  </div>
</template>

<script setup>
import MediumIcon from '@/assets/images/icons/medium.svg'
import InstagramIcon from '@/assets/images/icons/instagram.svg'
import LinkedinIcon from '@/assets/images/icons/linkedin.svg'
import TwitterIcon from '@/assets/images/icons/twitter.svg'
import EditSocialMedia from '@/shared/components/EditSocialMedia.vue'
import { computed } from 'vue'

const props = defineProps({
  isEditModeEnabled: {
    type: Boolean,
    default: false,
  },
  socialMedia: {
    type: Object,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
})

const socialsIcons = {
  medium: MediumIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  twitter: TwitterIcon,
}

const activeSocialMedia = computed(() =>
  Object.entries(props.socialMedia).filter((entry) => !!entry[1]),
)
</script>
